import React from "react";
import { Loader } from "../Loader";
import { SectionState } from "./useAnalyticsStream";

/**
 * The loading / failed / empty / rendered ladder every streamed section walks.
 *
 * One copy rather than eight, because each section now settles on its own: the
 * headline funnel appears the moment it lands instead of waiting on six
 * breakdowns, and a breakdown that fails says so in its own place rather than
 * blanking the ones beside it.
 */
const SectionBody = <T,>({
  section,
  isEmpty,
  emptyMessage,
  children,
}: {
  section: SectionState<T> | undefined;
  isEmpty?: (data: T) => boolean;
  emptyMessage: string;
  children: (data: T) => React.ReactNode;
}) => {
  if (!section || section.status === "pending") {
    return <Loader className="w-8 h-8" />;
  }

  if (section.status === "error") {
    return <div className="text-sm text-red-500">{section.message}</div>;
  }

  if (isEmpty?.(section.data)) {
    return <div className="text-sm text-gray-500">{emptyMessage}</div>;
  }

  return <>{children(section.data)}</>;
};

export default SectionBody;
